import React, { useState } from "react";
import { Modal, Button, Input, Checkbox, Space } from "antd";

const AddToyDialog = ({ open, features, onClose, onSave }) => {
  const [name, setName] = useState("");
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const [nameError, setNameError] = useState(false);
  const [featureError, setFeatureError] = useState(false);

  const handleNameChange = e => {
    setName(e.target.value);
  };

  const handleFeatureChange = (feature, e) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      setSelectedFeatures([...selectedFeatures, feature]);
    } else {
      setSelectedFeatures(selectedFeatures.filter(f => f !== feature));
    }
  };

  const handleSave = () => {
    if (name.trim() === "") {
      setNameError(true);
      return;
    }
    if (selectedFeatures.length === 0) {
      setFeatureError(true);
      return;
    }
    onSave(name, selectedFeatures);
    onClose();
  };

  return (
    <Modal
      title="Add"
      open={open}
      onCancel={onClose}
      width="auto"
      style={{ maxWidth: "500px" }}
      zIndex={1300}
      centered
      getContainer={() => {
        const mainContent = document.querySelector('main[component="main"]') ||
                           document.querySelector('main') ||
                           document.body;
        return mainContent;
      }}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="add" type="primary" onClick={handleSave}>
          Add
        </Button>,
      ]}
    >
      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        <div>
          <Input
          autoFocus
            placeholder="Name"
          value={name}
          onChange={handleNameChange}
            status={nameError ? "error" : ""}
          />
          {nameError && (
            <div style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px" }}>
              Name cannot be empty, or existing
            </div>
          )}
        </div>
        <Space direction="vertical" style={{ width: "100%" }}>
        {features.map(feature => (
            <Checkbox
              key={feature}
              onChange={e => handleFeatureChange(feature, e)}
              style={{ color: featureError ? "#ff4d4f" : "inherit" }}
            >
              {feature}
            </Checkbox>
          ))}
        </Space>
      </Space>
    </Modal>
  );
};

export default AddToyDialog;
